import Vue from 'vue'
import Router from 'vue-router'

import { Actions, Lessons, Action, ActionCreate, ActionEdit, Lesson, LessonCreate, LessonEdit } from './components/extended'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/patients/new',
      name: 'PatientCreate',
      component: () => import('./views/PatientCreate.vue')
    },
    {
      path: '/patients/:patientId(\\d+)',
      name: 'Patient',
      component: () => import('./views/Patient.vue'),
      props: route => ({ patientId: Number(route.params.patientId) }),
      redirect: { name: 'PatientMonitoring' },
      // NOTE: `PatientFeedback` deprecated in Migraine Care 2.0
      // redirect: { name: 'PatientFeedbackAndMonitoring' },
      children: [
        {
          name: 'PatientMonitoring',
          path: 'monitoring',
          component: () => import('./components/patients/PatientMonitoring.vue')
        },
        // NOTE: `PatientFeedback` deprecated in Migraine Care 2.0
        // {
        //   name: 'PatientFeedbackAndMonitoring',
        //   path: 'feedback-and-monitoring',
        //   component: () => import('./components/patients/PatientFeedbackAndMonitoring.vue')
        // },
        {
          name: 'CoachingContents',
          path: 'coaching-contents',
          component: () => import('./components/patients/CoachingContents.vue'),
          props: route => ({ patientId: Number(route.params.patientId) })
        },
        {
          name: 'PatientProfile',
          path: 'profile',
          component: () => import('./components/patients/PatientProfile.vue'),
          props: route => ({ patientId: Number(route.params.patientId) })
        },
        {
          name: 'PatientAppointments',
          path: 'appointments',
          component: () => import('./components/patients/PatientAppointments.vue')
        },
        {
          name: 'PatientQuestionnaireAnswers',
          path: 'questionnaire-answers',
          component: () => import('./components/patients/QuestionnaireAnswers.vue')
        },
        {
          path: '*',
          redirect: { name: 'PatientMonitoring' }
          // NOTE: `PatientFeedback` deprecated in Migraine Care 2.0
          // redirect: { name: 'PatientFeedbackAndMonitoring' }
        }
      ]
    },
    {
      path: '/patients',
      name: 'Patients',
      component: () => import('./views/Patients.vue')
    },
    {
      path: '/actions',
      name: 'Actions',
      component: Actions,
      props: {
        itemType: 'action',
        itemComponent: Action,
        detailsComponent: () => import('./components/actions/ActionDetails.vue'),
        previewComponent: () => import('./components/actions/ActionPreview.vue')
      }
    },
    {
      path: '/actions/:itemId(\\d+)',
      name: 'ActionEdit',
      component: ActionEdit,
      props: route => (
        {
          itemType: 'action',
          itemId: Number(route.params.itemId),
          itemForm: () => import('./components/actions/ActionForm.vue')
        }
      )
    },
    {
      path: '/actions/new',
      name: 'ActionCreate',
      component: ActionCreate,
      props: {
        itemType: 'action',
        itemForm: () => import('./components/actions/ActionForm.vue')
      }
    },
    {
      path: '/lessons',
      name: 'Lessons',
      component: Lessons,
      props: {
        itemType: 'lesson',
        itemComponent: Lesson,
        detailsComponent: () => import('./components/lessons/LessonDetails.vue'),
        previewComponent: () => import('./components/lessons/LessonPreview.vue')
      }
    },
    {
      path: '/lessons/new',
      name: 'LessonCreate',
      component: LessonCreate,
      props: {
        itemType: 'lesson',
        itemForm: () => import('./components/lessons/LessonForm.vue')
      }
    },
    {
      path: '/lessons/:itemId(\\d+)',
      name: 'LessonEdit',
      component: LessonEdit,
      props: route => (
        {
          itemType: 'lesson',
          itemId: Number(route.params.itemId),
          itemForm: () => import('./components/lessons/LessonForm.vue')
        }
      )
    },
    // {
    //   path: '/assessments',
    //   name: 'Assessments',
    //   component: () => import('./views/Assessments.vue')
    // },
    {
      path: '/assessments/:checkpoint',
      name: 'Assessment',
      component: () => import('./components/assessments/Assessment.vue'),
      props: true
    },
    {
      path: '/faqs',
      name: 'FAQs',
      component: () => import('./views/FrequentlyAskedQuestions.vue')
    },
    {
      path: '*',
      redirect: '/patients'
    }
  ]
})
